export const ACTION_LABELS: Record<string, string> = {
  member_role_changed: 'Role changed',
  member_removed: 'Member removed',
  invite_sent: 'Invite sent',
  invite_accepted: 'Invite accepted',
  subscription_activated: 'Subscription activated',
  subscription_canceled: 'Subscription canceled',
};

interface AuditDetails {
  memberEmail?: string;
  newRole?: string;
  email?: string;
  plan?: string;
  [key: string]: string | undefined;
}

export function describeAuditEntry(action: string, details: AuditDetails | null): string {
  const d = details;
  switch (action) {
    case 'member_role_changed':
      return `Changed ${d?.memberEmail ?? 'member'} to ${d?.newRole?.replace('_', ' ') ?? 'unknown'}`;
    case 'member_removed':
      return `Removed ${d?.memberEmail ?? 'member'}`;
    case 'invite_sent':
      return `Invited ${d?.email ?? 'member'}`;
    case 'invite_accepted':
      return `${d?.email ?? 'Member'} joined`;
    case 'subscription_activated':
      return `Subscription activated (${d?.plan ?? 'paid'})`;
    case 'subscription_canceled':
      return 'Subscription canceled';
    default:
      return action.replace(/_/g, ' ');
  }
}
